import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class TicketViewService {
  constructor(private http: HttpClient) {}

  getTicket(ticketId): Observable<any> {
    return this.http.get(`/admin/tickets/${ticketId}/`);
  }

  searchTicket(params): Observable<any> {
    return this.http.get(`/admin/tickets/by_hd_number/`, {
      params: params,
    });
  }

  getHdComments(ticket_number): Observable<any> {
    return this.http.get(`/async/ticket/comments/`, {
      params: { ticket_number: ticket_number },
    });
  }

  getEsasComments(ticket_number): Observable<any> {
    return this.http.get(`/admin/tickets/comments_by_hd_number/`, {
      params: { hd_ticket_number: ticket_number },
    });
  }

  getHdAbonentStatus(tickets): Observable<any> {
    // return this.http.get(`/async/ticket/line_info/`, {params: {login: login}});
    return this.http.post(`/async/tickets/line_info_one/`, tickets);
  }

  getHdGlobalProblem(house_id): Observable<any> {
    return this.http.get(`/async/ticket/gp_list/`, {
      params: { house_id: house_id },
    });
  }

  getTicketsStatuses(): Observable<any> {
    return this.http.get(`/admin/ticket_statuses/`);
  }

  ticketAddComment(ticketId, data): Observable<any> {
    return this.http.post(`/admin/tickets/${ticketId}/add_comment/`, data);
  }

  ticketChangeStatus(data): Observable<any> {
    return this.http.patch(`/async/ticket/change_status`, data);
  }

  changeWorkOrderStatus(work_order_id: string, state: string): Observable<any> {
    return this.http.post(`/async/mapic/work_order/patch_work_order_items_state`, {
      work_order_id,
      state,
    });
  }
}
